module.exports = __webpack_public_path__ + "static/media/icon-info-active.db6a66af.svg";